import script from "./UiPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./UiPagination.vue?vue&type=script&setup=true&lang=js"

import "./UiPagination.vue?vue&type=style&index=0&id=08799f1f&lang=scss"

const __exports__ = script;

export default __exports__